import { customCreateUsForm } from "@hardware/Services/ContactUsService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;

const capitalize = (word: string) => word[0].toUpperCase() + word.slice(1);

export const PopulateApiParameter: HandlerType = props => {
    const states = props.getState() as any;
    const state = states.createAccountForm as any;
    const formData = {
        emailTo: props.parameter.emailRecipients,
    } as any;

    for (const key in state.fieldValues) {
        const value = state.fieldValues[key];
        if (value) {
            if(capitalize(key) === "Brands"){
                formData[capitalize(key)] = value.split(",");
                continue;
            }
            if(capitalize(key) === "ValueAddedServices"){
                formData[capitalize(key)] = value.split(",");
                continue;
            }
            formData[capitalize(key)] = value;
        }
    }


    const authKey = formData["EmailAddress"] + formData["FirstName"];
    props.apiParameter = {
        emailTo: props.parameter.emailRecipients,
        AuthKey: authKey,
        ...formData,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await customCreateUsForm(props.apiParameter, props.parameter.emailRecipients);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
